import React from 'react';
import PropTypes from 'prop-types';

/**
 * @deprecated Use Telerik or shared components instead.
 */
const FormikLabel = ({
  label, wrapperClass, name, value,
}) => (
  <div className={`formik-wrapper ${wrapperClass || ''}`}>
    <label htmlFor={name}>{label}</label>
    <strong id={name}>{value}</strong>
  </div>
);

FormikLabel.propTypes = {
  label: PropTypes.string,
  inputProps: PropTypes.object,
  currency: PropTypes.bool,
  wrapperClass: PropTypes.string,
};

export default FormikLabel;
